(ns frontend.view.modals.confirmation.events)

(defn reset-state! [state]
  (reset! state {}))

(defn toggle-confirmed! [state val]
  (swap! state assoc-in [:confirmed?] val))

(defn toggle-extra! [state kw val]
  (swap! state assoc-in [kw] val))
